module.exports = "/_next/static/images/Hero2-a635000cfa313bd99492afb1cc0d2853.png";